import React, { ReactNode } from 'react';

interface BannerProps {
  children: ReactNode;
  className?: string;
}

export function Banner({ children, className }: BannerProps) {
  return (
    <div className={`flex h-10 items-center rounded-none border-t-0 border-r-0 border-b border-l-0 px-4 ${className}`}>
      {children}
    </div>
  );
}
